import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["videoWrapper"]

  connect() {
    document.addEventListener("keydown", this.hideHandler.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.hideHandler.bind(this))
  }

  hideHandler(event) {
    if (event.keyCode == 27) {
      this.hide(event)
    }
  }

  show(event) {
    event.preventDefault()
    this.videoWrapperTarget.classList.add("show")
  }

  hide(event) {
    event.preventDefault()
    this.pauseVideo()
    this.videoWrapperTarget.classList.remove("show")
  }

  pauseVideo() {
    const overlay = document.querySelector("#video-overlay-wrapper")

    const video = overlay.querySelector("video")
    const iframe = overlay.querySelector("iframe")

    if (iframe) {
      const iframeSrc = iframe.src
      iframe.src = iframeSrc
    }

    if (video) {
      video.pause()
    }
  }
}
